import React, { useMemo } from "react";
import { useUserContext } from "../../utils/UserContext";
import { mapToPresentable, mapejos } from "../../utils/Mapejos";
import LlistaRecursos from "./LlistaRecursos";
import { ChipActiu, MiniaturaRecurs } from "./RecursosComuns";

export const idEina = (e) => (e ? Number(e.idEines) : null);
export const esEinaActiva = (e) => Number(e.Activa) === 1;
const estatPresentable = (e) => mapToPresentable(e.Estat, mapejos.estatEina) || "—";
const text = (valor) => valor || "—";

const CLASSE_ESTAT = {
  OPERATIVA: "dv2-chip--ok",
  AVARIADA: "dv2-chip--warn",
  REPARACIO: "dv2-chip--warn",
  BAIXA: "dv2-chip--danger",
  PERDUDA: "dv2-chip--danger",
};

export function ChipEstatEina({ estat }) {
  return <span className={`dv2-chip ${CLASSE_ESTAT[estat] || ""}`}>{mapToPresentable(estat, mapejos.estatEina) || "—"}</span>;
}

export const ubicacioActual = (e) => (e.UbicacioActualNom ? e.UbicacioActualNom : "");

const COLUMNES = [
  {
    key: "Imatge",
    label: "",
    senseOrdre: true,
    render: (e) => <MiniaturaRecurs imatge={e.Imatge} alt={e.Nom} icona="🛠️" />,
  },
  { key: "Nom", label: "Nom", render: (e) => <strong>{e.Nom}</strong> },
  { key: "Marca", label: "Marca", render: (e) => text(e.Marca) },
  { key: "Model", label: "Model", render: (e) => text(e.Model) },
  { key: "NumeroSerie", label: "Número de sèrie", render: (e) => text(e.NumeroSerie) },
  { key: "Estat", label: "Estat", sortValue: estatPresentable, render: (e) => <ChipEstatEina estat={e.Estat} /> },
  { key: "UbicacioActualNom", label: "Ubicació actual", render: (e) => text(ubicacioActual(e)) },
  { key: "Activa", label: "Activa", sortValue: (e) => (esEinaActiva(e) ? 0 : 1), render: (e) => <ChipActiu actiu={esEinaActiva(e)} femeni /> },
];

const textCerca = (e) => [e.Nom, e.Marca, e.Model, e.NumeroSerie].filter(Boolean).join(" ");

const filtreFila = (e, filtres) => !filtres.estat || e.Estat === filtres.estat;

const renderTargeta = (e) => ({
  imatge: <MiniaturaRecurs imatge={e.Imatge} alt={e.Nom} icona="🛠️" />,
  titol: e.Nom,
  meta: [[e.Marca, e.Model].filter(Boolean).join(" "), estatPresentable(e), esEinaActiva(e) ? null : "Inactiva"]
    .filter((x) => x && x !== "—")
    .join(" · "),
});

const ORDRE_INICIAL = { key: "Nom", direction: "asc" };

function Seleccionareina(props) {
  const { empresaSeleccionada } = useUserContext();
  const cosPeticio = useMemo(
    () => ({ idEmpresa: empresaSeleccionada?.IdEmpresa || null }),
    [empresaSeleccionada]
  );

  const renderFiltres = ({ filtres, setFiltre, dades }) => {
    const estats = Array.from(new Set(dades.map((e) => e.Estat).filter(Boolean)));
    return (
      <div className="dv2-filter">
        <span className="dv2-filter-label">Estat</span>
        <select className="dv2-select" value={filtres.estat || ""} onChange={(ev) => setFiltre("estat", ev.target.value)}>
          <option value="">Totes</option>
          {estats.map((s) => (
            <option key={s} value={s}>
              {mapToPresentable(s, mapejos.estatEina)}
            </option>
          ))}
        </select>
      </div>
    );
  };

  return (
    <LlistaRecursos
      {...props}
      endpoint="Eines.php"
      clauDades="eines"
      cosPeticio={cosPeticio}
      idDe={idEina}
      esActiu={esEinaActiva}
      columnes={COLUMNES}
      textCerca={textCerca}
      filtreFila={filtreFila}
      renderFiltres={renderFiltres}
      renderTargeta={renderTargeta}
      placeholderCerca="Cerca per nom, marca, model o número de sèrie…"
      etiquetaPlural="eines"
      femeni
      ordreInicial={ORDRE_INICIAL}
    />
  );
}

export default Seleccionareina;
